import apiClient from "./BuyModule-service/axois.config-buy";
const sellfromdata = (formData) => {
  const apiPath = process.env.REACT_APP_API_BUY_URL;
  const payload = {
    firstName: formData.firstName,
    lastName:  formData.lastName,
    emailId:  formData.email,
    contactNumber: formData.contactNumber,
    whatsapNumber: formData.whatsappNumber,
    propertyName:formData.PropertyName,
    propertyType:formData.propertyType,
    type: formData.apartmentType,
    bhkType: formData.bedRoomType,
    location: formData.propertyLocation,
    propertyDetails: formData.propertyDetails,
    constructionStatus:formData.status,
  };
  return apiClient.post(
    apiPath.replace("/website/buy", "/sale/customer/enquiry/create"),
    payload
  );
};
export default sellfromdata;
